import { render } from "./ProductReportView.vue?vue&type=template&id=a7bbf664&scoped=true"
import script from "./ProductReportView.vue?vue&type=script&lang=js"
export * from "./ProductReportView.vue?vue&type=script&lang=js"

import "./ProductReportView.vue?vue&type=style&index=0&id=a7bbf664&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7bbf664"]])

export default __exports__